// extracted by mini-css-extract-plugin
module.exports = {"container":"KiaView_container__3FZbA","section":"KiaView_section__1CZ20","box":"KiaView_box__3DB0T","image":"KiaView_image__2PidS","imageFixed":"KiaView_imageFixed__25kEY"};